import React from 'react';
import { Select } from 'antd';

export const select = Select;

